import React, {Fragment} from 'react';

import {Stack, Typography} from '@mui/material';
import Grid from '@mui/material/Grid2';
import {AppointmentBookingEnum} from 'main/analytics/gaTagsEnum';
import {
	ErrorState,
	IconIllustration,
	MainFooter,
	MainHeader,
	SentinelLoading,
} from 'presentation/components';
import {Filter} from 'presentation/components/Filter';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import {formatText} from 'presentation/utils';
import {ExamCard} from '../../../../components/ExamCard';
import {useProcedureSelection} from '../../hooks/useProcedureSelection';
import {StyledFooterContainer} from './styles';

const {failToLoadDescription} = translations['pt-br'].commons;
const {title, searchProcedure, errorState} =
	translations['pt-br'].privateFlow.bookingFlow.examSelection.procedureSelection;

export function ProcedureSelection() {
	const {isMobile} = useMediaQueries();

	const {
		procedures,
		isLoading,
		isError,
		isFetchingNextPage,
		hasNextPage,
		handleRefresh,
		handleGoBack,
		handleGoToGuideFlow,
		fetchNextPage,
		showEmptyState,
		emptyContent,
	} = useProcedureSelection();

	return (
		<Fragment>
			<MainHeader title={title} handleBack={handleGoBack} variant={'subRoute'} hideClose />

			<Filter.Root>
				<Filter.Search placeholder={searchProcedure} />
			</Filter.Root>

			{procedures && !isError ? (
				<Fragment>
					<Grid container rowSpacing={2} columnSpacing={3} margin={isMobile ? 2 : 4}>
						{procedures.map(item => (
							<Grid key={item.cD_PROCEDIMENTO} size={{xs: 12, lg: 6}}>
								<ExamCard
									dataTagId={AppointmentBookingEnum.SELECIONOU_EXAME}
									text={formatText(item?.nM_PROCEDIMENTO)}
									handleClick={() =>
										handleGoToGuideFlow(
											item?.nM_PROCEDIMENTO,
											item?.cD_PROCEDIMENTO,
										)
									}
								/>
							</Grid>
						))}
					</Grid>

					<SentinelLoading
						minHeight="200px"
						onVisible={() => {
							if (procedures.length > 0 && hasNextPage) {
								fetchNextPage();
							}
						}}
						isLoading={isLoading || isFetchingNextPage}
					/>
				</Fragment>
			) : null}

			{showEmptyState ? (
				<Stack sx={{height: '100%', p: 2}} alignItems="center" gap={2}>
					<IconIllustration variant="default" customIconName="search-default" />
					<Stack alignItems="center" textAlign="center" gap={1}>
						<Typography variant="h6" color="text.primary" fontWeight={600}>
							{emptyContent.title}
						</Typography>
						<Typography color="text.primary" maxWidth="225px">
							{emptyContent.description}
						</Typography>
					</Stack>
				</Stack>
			) : null}

			{isError ? (
				<Stack sx={{height: 'initial', p: 2}} gap={2}>
					<ErrorState
						title={errorState.title}
						description={failToLoadDescription}
						handleRefresh={handleRefresh}
					/>
				</Stack>
			) : null}

			<StyledFooterContainer>
				<MainFooter />
			</StyledFooterContainer>
		</Fragment>
	);
}
